<div class="container-full d-flex" id="container-color">
  <div class="col preview-wrapper">
    <div class="row">
      <div class="col-lg-1 d-flex justify-content-center">
        <div class="ticket-component-list" [ngClass]="{'is-rendering-canvas': isRenderingCanvas}">
          @for (component of ticketTemplateComponentTypes; track component; let i = $index) {
            <div id="{{component.id}}-{{component.name}}"
              [attr.type]="component.id"
              [attr.name]="component.name"
              [attr.componentType]="component.id"
              class="meta-icon" [ngClass]="{'m-t-8': i >= 1}" draggable="true">
              <div class="col-8 icon-container">
                <span class="cm-icon cm-icon-{{component.icon}} icon-styling" aria-hidden="true"></span>
                <div class="icon-component-name">{{ component.name }}</div>
              </div>
            </div>
          }
        </div>
      </div>

      <div class="page-container" [ngClass]="{'is-rendering-canvas': isRenderingCanvas}">
        <div class="fixed-ratio" [style.padding-bottom.%]="shallowTicketTemplateInformation.ratio * 100">
          <div #konvaContainer id="konva-container"></div>
        </div>
      </div>
    </div>
    @if (isRenderingCanvas && !isViewPortTooLow) {
      <cm-indicator class="fs-large"></cm-indicator>
    }

    <cm-dialog #componentDialog class="cm-dialog" data-show-top-divider data-show-bottom-divider
      data-max-width="600px" data-max-height="calc(70vh - 280px)">
      <h5 slot="header" class="dialog-title">{{ ('Ticket_Template.Select_Component' | trans) | async }}</h5>

      <div slot="body" class="form-row">
        @if (selectionComponent$ | async; as selections;) {
          <div class="form-group m-b-16">
            <div class="d-flex">
              <cm-input id="formControl1" id="filterInput"
                type="text"
                value="{{searchSelectedValue}}"
                placeholder="Filter"
                data-icons-left="search"
                (input)="filterComponents($event.target.value)">
              </cm-input>
            </div>
          </div>
          <div class="card-wrapper list-view">
            <div class="card-container">
              @for (selection of selections; track selection) {
                <div class="card" (click)="renderSelectedComponent(selection)">
                  <div class="card-header">
                    <div class="meta-icon">
                      <span class="cm-icon cm-icon-{{selection.icon}}" aria-hidden="true"></span>
                    </div>
                    <div class="meta-title">
                      <span class="heading">{{ selection.title }}</span>
                    </div>
                  </div>
                  <div class="card-media list">
                    {{ selection.description }}
                  </div>
                </div>
              }
            </div>
          </div>
        }
      </div>

      <div slot="footer">
        <button id="close-dialog" class="btn btn-secondary"
          (click)="onComponentDialogClose()">{{ ('Generic.Forms.Cancel_Button' | trans) | async }}
        </button>
      </div>
    </cm-dialog>
  </div>

  @if (ticketTemplatesComponents != null) {
    <app-wide-sidebar>
      @if (component$ | async; as component) {
        <cm-button
          data-icon="left"
          data-label="{{('Ticket_Template.Return_Button' | trans) | async}}"
          data-button-type="icon-text"
          data-button-size="medium"
          (click)="returnToSaveView()">
        </cm-button>
        <div class="row justify-content-space-between">
          <div class="col-lg-10">
            <p class="bold">{{ component.title }}</p>
          </div>
          <div class="col-lg-2">
            <cm-button
              data-icon="delete"
              data-button-type="icon"
              data-button-size="medium"
              (click)="deleteComponent()">
            </cm-button>
          </div>
        </div>
        <div class="form-group">
          <div class="d-flex justify-content-space-between">
            <div class="p-r-8">
              <cm-input id="positionX"
                class="width-cm-input"
                type="number"
                ngDefaultControl
                data-label="Pos X (px)"
                [(ngModel)]="component.positionX"
                data-icons-left="reorder"
                (input)="changePositionX($event)">
              </cm-input>
            </div>
            <div class="p-l-8">
              <cm-input id="positionY"
                class="width-cm-input"
                type="number"
                ngDefaultControl
                data-label="Pos Y (px)"
                [(ngModel)]="component.positionY"
                data-icons-left="reorder"
                step="1"
                (input)="changePositionY($event)">
              </cm-input>
            </div>
          </div>
        </div>
        <div class="form-group m-t-20">
          <div class="d-flex justify-content-space-between">
            <div class="p-r-8">
              <cm-input id="width"
                type="number"
                ngDefaultControl
                data-label="Width (px)"
                [(ngModel)]="component.width"
                data-icons-left="maximize"
                step="1"
                (input)="changeWidth($event)">
              </cm-input>
            </div>
            <div class="p-l-8">
              <cm-input id="height"
                type="number"
                ngDefaultControl
                data-label="Height (px)"
                [(ngModel)]="component.height"
                data-icons-left="maximize"
                step="1"
                (input)="changeHeight($event)">
              </cm-input>
            </div>
          </div>
        </div>
        @if (component.fontSize != null) {
          <div class="form-group m-t-20">
            <cm-input id="fontsize"
              type="number"
              ngDefaultControl
              data-label="{{('Ticket_Template.Font_Size' | trans) | async}}"
              [(ngModel)]="component.fontSize"
              data-icons-left="font-size"
              step="1"
              (input)="changeFontSize($event)">
            </cm-input>
          </div>
        }
        @if (component.type === 'IMAGE_GENERAL') {
          <div class="form-group m-t-20">
            <cm-file-upload accept="image/*" attr.data-max-file-size="{{aurora1MBFileSize}}"
              data-display="{{('Email_Template_Groups.Drop_Files' | trans) | async}}"
              (change)="changeImage()">
            </cm-file-upload>
            @if (qualityImagePercentage) {
              <h6 class="m-t-16">{{ ('Ticket_Template.Image_Quality' | trans) | async }}</h6>
                        <div class="quality-meter row" [ngClass]="{'error': qualityImagePercentage < 40,
                                                            'warning': qualityImagePercentage < 99 && qualityImagePercentage >= 40,
                                                            'success': qualityImagePercentage >= 99}">
                            <div class="quality-circle full-color"></div>
                            <div class="quality-circle" [ngClass]="{'full-color': qualityImagePercentage > 39}"></div>
                            <div class="quality-circle" [ngClass]="{'full-color': qualityImagePercentage > 59}"></div>
                            <div class="quality-circle" [ngClass]="{'full-color': qualityImagePercentage > 79}"></div>
                            <div class="quality-circle" [ngClass]="{'full-color': qualityImagePercentage >= 99}"></div>
                        </div>

                        <div class="m-t-16">
                            <cm-button data-button-type="icon-text"
                                       data-button-style="primary"
                  data-icon="fit-horizontal"
                  data-label="{{('Ticket_Template.Full_Width_Image' | trans) | async}}"
                  (click)="fitImageHorizontal()">
                </cm-button>
              </div>
            }
          </div>
        }
        @if (component.fontAlignment != null) {
          <div class="form-group m-t-20">
            <cm-select data-label="{{('Ticket_Template.Font_Alignment' | trans) | async}}" id="font-alignment"
              placeholder="{{('Ticket_Template.Font_Alignment_Placeholder' | trans) | async}}"
              ngDefaultControl
              [(ngModel)]="component.fontAlignment"
              (input)="updateFontProperties({alignment: component.fontAlignment})">
              <cm-option slot="option" data-display="Left" data-icon="align-left" value="left"></cm-option>
              <cm-option slot="option" data-display="Center" data-icon="align-center"
              value="center"></cm-option>
            </cm-select>
          </div>
        }
        @if (component.fontStyle != null) {
          <div class="form-group m-t-20">
            <cm-select data-label="{{('Ticket_Template.Font_Style' | trans) | async}}" id="font-style"
              placeholder="{{('Ticket_Template.Font_Style_Placeholder' | trans) | async}}"
              ngDefaultControl
              [(ngModel)]="component.fontStyle"
              (input)="updateFontProperties({style: component.fontStyle})">
              <cm-option slot="option" data-display="Normal" data-icon="text" value="normal"></cm-option>
              <cm-option slot="option" data-display="Italic" data-icon="italic" value="italic"></cm-option>
              <cm-option slot="option" data-display="Bold" data-icon="bold" value="bold"></cm-option>
            </cm-select>
          </div>
        }
        @if (component.fontFamily != null) {
          <div class="form-group m-t-20">
            <cm-select data-label="{{('Ticket_Template.Font_Family' | trans) | async}}" id="font-family"
              placeholder="{{('Ticket_Template.Font_Family_Placeholder' | trans) | async}}"
              ngDefaultControl
              [(ngModel)]="component.fontFamily"
              (input)="updateFontProperties({family: component.fontFamily})">
              <cm-option slot="option" data-display="Monospace" value="Space Mono"></cm-option>
              <cm-option slot="option" data-display="Roboto" value="Roboto Condensed"></cm-option>
            </cm-select>
          </div>
        }
        @if (component.type === 'DYNAMIC_TEXT_COMPONENT') {
          <div class="form-group m-t-20">
            <cm-textarea id="dynamicText"
              ngDefaultControl
              [(ngModel)]="component.text"
              value="{{component.text}}"
              data-label="{{('Ticket_Template.Text_Editor' | trans) | async}}"
              (input)="updateFontProperties({text: component.text})">
            </cm-textarea>
          </div>
        }
        @if (component.type === 'TICKET_COMPONENT_HORIZONTAL') {
          <div class="form-group m-t-20">
            <label style="padding: 0">{{ ('Ticket_Template.Options' | trans) | async }}</label>
            <div class="form-check">
              <label>
                <input type="checkbox" value="event_date" ngDefaultControl
                  [(ngModel)]="printableTicketBoxOptions.event_date"/>
                <span
                class="label"> {{ ('Ticket_Template_List.Showing_Event_Date' | trans) | async }} </span>
              </label>
            </div>
            <div class="form-check">
              <label>
                <input type="checkbox" value="expiry_date" ngDefaultControl
                  [(ngModel)]="printableTicketBoxOptions.expiry_date"/>
                <span
                class="label"> {{ ('Ticket_Template_List.Showing_Expiry_Date' | trans) | async }} </span>
              </label>
            </div>
            <div class="form-check">
              <label>
                <input type="checkbox" value="ticket_price" ngDefaultControl
                  [(ngModel)]="printableTicketBoxOptions.ticket_price"/>
                <span class="label"> {{ ('Ticket_Template_List.Showing_Price' | trans) | async }} </span>
              </label>
            </div>
            <div class="form-check">
              <label>
                <input type="checkbox" value="purchase_date" ngDefaultControl
                  [(ngModel)]="printableTicketBoxOptions.purchase_date"/>
                <span
                class="label"> {{ ('Ticket_Template_List.Showing_Purchase_Date' | trans) | async }} </span>
              </label>
            </div>
            <div class="form-check">
              <label>
                <input type="checkbox" value="compact" ngDefaultControl
                  [(ngModel)]="printableTicketBoxOptions.compact"/>
                <span
                class="label"> {{ ('Ticket_Template_List.Use_Compact_Design' | trans) | async }} </span>
              </label>
            </div>
            <p>{{ ('Ticket_Template_List.Description' | trans) | async }}</p>
          </div>
        }
        <div class="form-group m-t-20">
          @if (component.rotation === 0) {
            <cm-button
              data-icon="scale"
              disabled
              data-label="{{('Ticket_Template.Reset_Rotation' | trans) | async}}"
              data-button-style="cta"
              data-button-type="icon-text"
              data-button-size="medium">
            </cm-button>
          } @else {
            <cm-button
              data-icon="scale"
              data-label="{{('Ticket_Template.Reset_Rotation' | trans) | async}}"
              data-button-style="cta"
              data-button-type="icon-text"
              data-button-size="medium"
              (click)="resetRotation()">
            </cm-button>
          }
        </div>
      } @else {
        <div class="section section-fields">
          <div class="form-group m-t-20">
            <div class="form-row">
              <cm-input id="template-name"
                type="text"
                value="{{templateName}}"
                [attr.placeholder]="('Ticket_Template.Set_Name' | trans) | async"
                data-label="{{('Ticket_Template.Template_Name' | trans) | async}}"
                (input)="changeTemplateName($event.target.value)"
                >
              </cm-input>
            </div>
          </div>
          <div class="form-group">
            <div class="form-row">
              <cm-input id="template-type"
                type="text"
                value="{{templateTypeWithDimensions}}"
                readonly
                data-label="{{('Ticket_Template.Template_Size' | trans) | async}}">
              </cm-input>
            </div>
          </div>
          <div class="form-group">
            <div class="form-row">
              <cm-color-picker
                data-hide-alpha="true"
                data-color="#FFFFFF"
                data-label="{{('Ticket_Template.Template_Background_Color' | trans) | async}}"
                [attr.data-color]="backgroundColor"
                (change)="setBackgroundColor($event.detail.hex)"
              ></cm-color-picker>
            </div>
          </div>
          <div class="form-group">
            <div class="form-group m-t-20">
              <div class="d-flex justify-content-space-between">
                <cm-button [attr.data-label]="'Generic.Forms.Close_Button' | trans | async"
                data-button-style="secondary" (click)="closeWithoutSave()"></cm-button>
                @if (ticketTemplateUuid != null) {
                  <div class="p-l-8">
                    @if (!isUpdating) {
                      <cm-button
                        [cmTicketingIsLoading]="isLoading"
                        id="saveButtonLoading"
                        data-icon="save"
                        [attr.data-label]="'Generic.Forms.Save_Button' | trans | async"
                        data-button-style="cta"
                        data-button-type="icon-text"
                        data-button-size="medium"
                        (click)="saveTemplate()">
                      </cm-button>
                    } @else {
                      <cm-button
                        [cmTicketingIsLoading]="isLoading"
                        id="saveButtonButRender"
                        data-icon="save"
                        [attr.data-label]="'Generic.Forms.Save_Button' | trans | async"
                        disabled
                        data-button-style="cta"
                        data-button-type="icon-text"
                        data-button-size="medium"
                        (click)="saveTemplate()">
                      </cm-button>
                    }
                  </div>
                } @else {
                  <cm-button
                    [cmTicketingIsLoading]="isLoading"
                    id="saveButtonNoteUpdate"
                    data-icon="save"
                    [attr.data-label]="'Generic.Forms.Save_Button' | trans | async"
                    data-button-style="cta"
                    data-button-type="icon-text"
                    data-button-size="medium"
                    (click)="saveTemplate()">
                  </cm-button>
                }
              </div>
            </div>
          </div>
        </div>
      }
    </app-wide-sidebar>
  }
</div>

<cm-dialog class="cm-dialog" #viewPortModal data-min-height="200" (cm-dialog-closed)="returnToOverview()">
  <div slot="body" class="dialog-body smPadding">
    <cm-image
      data-type="error">
    </cm-image>
    <h3 class="text-center m-b-16">
      {{ ('Ticket_Template.Viewport_Modal_Title' | trans) | async }}
    </h3>
    <div class="text-center">
      {{ ('Ticket_Template.Viewport_Modal_Body' | trans) | async }}
    </div>
  </div>
  <div slot="footer" class="col-12">
    <div class="row">
      <div class="col-12 text-right">
        <cm-button
          (click)="returnToOverview()"
          data-label="{{('Ticket_Template.Return_Overview_Button' | trans) | async}}"
          data-button-type="icon-text"
          data-icon="left"
          data-custom-class="m-l-16"
          data-button-style="cta">
        </cm-button>
      </div>
    </div>
  </div>
</cm-dialog>


<cm-dialog class="cm-dialog" #confirmationModal>
  <div slot="body" class="dialog-body smPadding">
    <cm-image
      data-type="scientist">
    </cm-image>
    <h3 class="text-center m-b-16">
      {{ ('Ticket_Template.Confirm_Modal_Title' | trans) | async }}
    </h3>
    <div class="text-center">
      {{ ('Ticket_Template.Confirm_Modal_Body' | trans) | async }}
    </div>
  </div>
  <div slot="footer" class="col-12">
    <div class="row">
      <div class="col-6">
        <cm-button
          (click)="onCancel()"
          data-label="{{('Ticket_Template.Confirm_Cancel_Button' | trans) | async}}"
          data-button-type="icon-text"
          data-icon="block"
          data-button-style="secondary">
        </cm-button>
      </div>
      <div class="col-6 text-right">
        <cm-button
          (click)="onAccept()"
          data-label="{{('Ticket_Template.Confirm_Navigate_Button' | trans) | async}}"
          data-button-type="icon-text"
          data-icon="check"
          data-custom-class="m-l-16"
          data-button-style="cta">
        </cm-button>
      </div>
    </div>
  </div>
</cm-dialog>


<cm-dialog class="cm-dialog" #imageNotLoadedModal data-max-height="550px" (cm-dialog-closed)="returnToOverview()">
  <div slot="body" class="dialog-body smPadding">
    <div class="text-center">
      <!-- THIS IS TEMPORARY UNTIL AVAILABLE IN AURORA-->
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="286px"
        height="185px" viewBox="0 0 286 185" version="1.1">
        <title>Group 5</title>
        <defs>
          <path
            d="M23.3591686,4.01506255 C16.7906341,7.20368155 11.2243877,12.5174411 7.1624831,18.9500781 L7.1624831,18.9500781 C6.25933235,20.3541239 5.44076671,21.8108442 4.71315281,23.3129734 L4.71315281,23.3129734 C2.20015629,28.3224928 0.651248197,33.7633975 0.148285087,39.3505191 L0.148285087,39.3505191 C0,41.1550722 -0.037256458,42.9668908 0.037323967,44.776893 L0.037323967,44.776893 C0.102809218,46.2190824 0.251060551,47.657639 0.482987482,49.0834812 L0.482987482,49.0834812 C0.593948602,49.8109332 0.704909722,50.5383851 0.87226092,51.2649289 L0.87226092,51.2649289 C1.26153436,53.1112583 2.20834195,59.3195748 4.93598456,65.1936813 L4.93598456,65.1936813 C5.72089806,66.8756301 6.65224385,68.4858328 7.71910774,70.0043093 L7.71910774,70.0043093 C8.8841995,71.6971563 10.3339702,73.1738565 12.0038441,74.3672046 L12.0038441,74.3672046 C14.5486737,76.1445124 17.5891903,77.0654066 20.6870065,76.9963849 L20.6870065,76.9963849 C21.1353986,76.9873031 21.5810621,76.9491596 22.0230875,76.8837706 L22.0230875,76.8837706 C23.9421692,76.4741816 25.7357375,75.612319 27.255541,74.3672046 L27.255541,74.3672046 C28.8344632,73.0694158 30.2705911,71.6072465 31.5411869,70.0043093 L31.5411869,70.0043093 C32.7945018,68.4640365 33.9650507,66.8583747 35.0482859,65.1936813 L35.0482859,65.1936813 C38.6108655,59.7673074 41.8942232,53.6143898 44.9565682,49.0834812 L44.9565682,49.0834812 C45.9033758,47.606781 46.984792,46.2208987 48.1844454,44.943998 L48.1844454,44.943998 L48.4072771,44.7196776 C50.0771511,42.9868707 51.6915444,41.1968485 53.1940671,39.294212 L53.1940671,39.294212 C58.0927277,33.1412944 60.3747068,27.7712277 60.8758509,23.1840119 L60.8758509,23.1840119 C61.041383,21.7409143 61.041383,20.2823777 60.8758509,18.838372 L60.8758509,18.838372 C59.7626016,10.2796863 52.3591302,4.7425145 46.0134274,1.77730771 L46.0134274,1.77730771 C43.3931078,0.484967971 40.6518225,0 38.0042174,0 L38.0042174,0 C31.4857063,0 25.5365532,2.94159412 23.3591686,4.01506255 L23.3591686,4.01506255 Z"
            id="path-1"/>
          <path
            d="M49.0823094,27.8053196 C47.7474922,28.8638196 46.4117688,29.9784591 45.0769517,31.147427 L45.0769517,31.147427 C39.5727565,35.941916 34.5080633,41.2181176 29.9408681,46.9126485 L29.9408681,46.9126485 C28.6051447,48.6393889 27.2694214,50.3661293 25.9898818,52.2042431 L25.9898818,52.2042431 C24.9885424,53.5977688 24.0424805,54.990389 23.1516962,56.4382432 L23.1516962,56.4382432 C20.5699623,60.4739443 18.2646161,64.6798747 16.2519692,69.0279646 L16.2519692,69.0279646 C15.8623077,69.8075784 15.3611849,70.8651729 14.6933232,72.2025592 L14.6933232,72.2025592 C14.0263677,73.5390399 13.2461385,75.1553124 12.4124442,76.9372868 L12.4124442,76.9372868 C11.8560438,78.2185336 11.1881821,79.6672933 10.5203205,81.1712869 L10.5203205,81.1712869 C10.0744752,82.1745529 9.63044235,83.233053 9.18459711,84.3467869 L9.18459711,84.3467869 C8.96258068,84.84842 8.79493562,85.3491475 8.57291918,85.8507806 L8.57291918,85.8507806 C7.23719583,89.192888 5.90147247,92.8138816 4.67721043,96.6576221 L4.67721043,96.6576221 C-1.83376128,117.212805 -4.55957936,143.784868 17.1418473,159.716697 L17.1418473,159.716697 C43.4068444,178.990633 102.558365,139.662241 132.606704,135.205495 L132.606704,135.205495 C152.305452,132.309786 167.441535,127.630292 178.904833,121.725691 L178.904833,121.725691 C180.981819,120.695261 183.006246,119.560701 184.969959,118.326539 L184.969959,118.326539 C185.526359,117.992419 186.081854,117.658299 186.582976,117.325084 L186.582976,117.325084 C191.444683,114.202101 195.83064,110.393675 199.604014,106.015704 L199.604014,106.015704 C200.759405,104.667452 201.836865,103.2531 202.831861,101.782609 L202.831861,101.782609 C204.731234,98.9267419 206.334283,95.8843466 207.617448,92.7025082 L207.617448,92.7025082 C213.572019,77.6227312 210.900572,61.0625029 205.502401,46.9126485 L205.502401,46.9126485 L194.986072,26.9143324 C180.184372,8.47524396 154.197575,3.46253557 145.962125,1.84716856 L145.962125,1.84716856 C139.540866,0.603046205 132.974617,0 126.355808,0 L126.355808,0 C99.1927775,0 71.1860842,10.1576161 49.0823094,27.8053196 L49.0823094,27.8053196 Z"
            id="path-3"/>
          <path
            d="M3.08884634,13.3054852 C-3.02157247,18.6123289 0.510003912,28.5151479 8.63872636,28.788348 L8.63872636,28.788348 C10.0391634,28.8431707 11.4550698,28.5672295 12.8755261,28.2931156 L12.8755261,28.2931156 C14.3551301,28.0071236 15.8411039,27.7211315 17.3279876,27.8042793 L17.3279876,27.8042793 C31.8473983,28.4603251 49.8983853,36.5576476 64.865499,36.995316 L64.865499,36.995316 C79.8326128,37.4329844 84.5416846,7.06848192 47.711738,0.831478613 L47.711738,0.831478613 C44.3130166,0.259494424 41.0744492,0 37.9933057,0 L37.9933057,0 C22.2172326,0 10.5924224,6.80624636 3.08884634,13.3054852 L3.08884634,13.3054852 Z"
            id="path-5"/>
          <path
            d="M0,12.5 C0,19.4037356 18.5807843,25 41.5004555,25 L41.5004555,25 C64.4201267,25 83,19.4037356 83,12.5 L83,12.5 C83,5.59626437 64.4201267,0 41.5004555,0 L41.5004555,0 C18.5807843,0 0,5.59626437 0,12.5 L0,12.5 Z"
            id="path-7"/>
          <path
            d="M7.12589209,0 C3.19152982,0 0,3.19065552 0,7.12598007 L0,7.12598007 L0,66.8749336 C0,70.8093445 3.19152982,74 7.12589209,74 L7.12589209,74 L66.8741079,74 C70.8093839,74 74,70.8093445 74,66.8749336 L74,66.8749336 L74,7.12598007 C74,3.19065552 70.8093839,0 66.8741079,0 L66.8741079,0 L7.12589209,0 Z"
            id="path-9"/>
          <path
            d="M7.12589209,0 C3.19152982,0 0,3.19065552 0,7.12598007 L0,7.12598007 L0,66.8749336 C0,70.8093445 3.19152982,74 7.12589209,74 L7.12589209,74 L66.8741079,74 C70.8093839,74 74,70.8093445 74,66.8749336 L74,66.8749336 L74,7.12598007 C74,3.19065552 70.8093839,0 66.8741079,0 L66.8741079,0 L7.12589209,0 Z"
            id="path-11"/>
          <path
            d="M7.12589209,0 C3.19152982,0 0,3.1897812 0,7.12515434 L0,7.12515434 L0,66.8748457 C0,70.8102188 3.19152982,74 7.12589209,74 L7.12589209,74 L66.8741079,74 C70.8093839,74 74,70.8102188 74,66.8748457 L74,66.8748457 L74,7.12515434 C74,3.1897812 70.8093839,0 66.8741079,0 L66.8741079,0 L7.12589209,0 Z"
            id="path-13"/>
          <path
            d="M7.12589209,0 C3.19152982,0 0,3.1897812 0,7.12515434 L0,7.12515434 L0,66.8748457 C0,70.8102188 3.19152982,74 7.12589209,74 L7.12589209,74 L66.8741079,74 C70.8093839,74 74,70.8102188 74,66.8748457 L74,66.8748457 L74,7.12515434 C74,3.1897812 70.8093839,0 66.8741079,0 L66.8741079,0 L7.12589209,0 Z"
            id="path-15"/>
          <path
            d="M7.12589209,0 C3.19152982,0 0,3.19065552 0,7.12598007 L0,7.12598007 L0,66.8749336 C0,70.8093445 3.19152982,74 7.12589209,74 L7.12589209,74 L66.8741079,74 C70.8093839,74 74,70.8093445 74,66.8749336 L74,66.8749336 L74,7.12598007 C74,3.19065552 70.8093839,0 66.8741079,0 L66.8741079,0 L7.12589209,0 Z"
            id="path-17"/>
          <path
            d="M7.12589209,0 C3.19152982,0 0,3.19065552 0,7.12598007 L0,7.12598007 L0,66.8749336 C0,70.8093445 3.19152982,74 7.12589209,74 L7.12589209,74 L66.8741079,74 C70.8093839,74 74,70.8093445 74,66.8749336 L74,66.8749336 L74,7.12598007 C74,3.19065552 70.8093839,0 66.8741079,0 L66.8741079,0 L7.12589209,0 Z"
            id="path-19"/>
          <path
            d="M15.0116204,0.61763042 C14.2320852,0.998487216 13.5889687,1.47570537 13.0822708,2.05020261 L13.0822708,2.05020261 C12.0688751,3.18543118 11.499072,4.57211701 11.499072,5.86978331 L11.499072,5.86978331 C11.499072,6.04782239 11.5102082,6.21760192 11.5306246,6.38095737 L11.5306246,6.38095737 C13.1045433,6.506686 14.5550355,5.70459241 15.7558909,4.3188243 L15.7558909,4.3188243 C16.7497983,3.14963982 17.249072,1.88960035 17.249072,0.539623606 L17.249072,0.539623606 C17.249072,0.359749071 17.2397918,0.179874535 17.2203034,0 L17.2203034,0 C16.5270739,0.0348736344 15.7911556,0.242279986 15.0116204,0.61763042 L15.0116204,0.61763042 Z M13.9861604,6.95453688 C12.6906472,7.42533094 11.9250323,7.66026911 11.7004519,7.66026911 L11.7004519,7.66026911 C11.398846,7.66026911 10.7093286,7.46020458 9.63746772,7.06191097 L9.63746772,7.06191097 C8.56189477,6.66453508 7.69698192,6.46171736 7.03716107,6.46171736 L7.03716107,6.46171736 C5.83073757,6.48282509 4.71061975,6.79118144 3.67495158,7.40147004 L3.67495158,7.40147004 C2.63835539,8.00808773 1.81056327,8.83863087 1.18786314,9.88851081 L1.18786314,9.88851081 C0.396263719,11.1962721 0,12.7573261 0,14.5670842 L0,14.5670842 C0,16.1464927 0.293253712,17.7763763 0.878833118,19.4631589 L0.878833118,19.4631589 C1.42450775,21.0223775 2.12237734,22.3916265 2.97058586,23.5718237 L2.97058586,23.5718237 C3.76032924,24.6767672 4.4201501,25.4559177 4.94819238,25.9120281 L4.94819238,25.9120281 C5.77505649,26.6709885 6.60192059,27.032573 7.43342479,26.9976994 L7.43342479,26.9976994 C7.97909942,26.9793448 8.69367334,26.7957994 9.58085862,26.4397212 L9.58085862,26.4397212 C10.4671159,26.0854785 11.293052,25.9120281 12.066091,25.9120281 L12.066091,25.9120281 C12.8020094,25.9120281 13.606601,26.0854785 14.4835781,26.4397212 L14.4835781,26.4397212 C15.3559151,26.7957994 16.1066817,26.9692498 16.7293819,26.9692498 L16.7293819,26.9692498 C17.5952227,26.9481421 18.4035265,26.5975703 19.1589332,25.9120281 L19.1589332,25.9120281 C19.6452147,25.4935445 20.278123,24.7400904 21.048378,23.6507482 L21.048378,23.6507482 C21.614469,22.8532433 22.1044626,21.9841556 22.5174306,21.040732 L22.5174306,21.040732 C22.6863299,20.6406029 22.847805,20.2248725 23,19.7898698 L23,19.7898698 C22.3002744,19.5007857 21.6720061,19.0905617 21.1077711,18.5628685 L21.1077711,18.5628685 C19.867011,17.423969 19.2350307,15.9923146 19.2146143,14.2660697 L19.2146143,14.2660697 C19.1951259,12.0571002 20.2113057,10.3326908 22.2668657,9.10110085 L22.2668657,9.10110085 C21.1189074,7.4877364 19.3927937,6.59295236 17.095949,6.40757146 L17.095949,6.40757146 C16.9771627,6.39747646 16.8546643,6.39288782 16.7284538,6.39288782 L16.7284538,6.39288782 C15.9544868,6.39288782 15.041317,6.57826872 13.9861604,6.95453688 L13.9861604,6.95453688 Z"
            id="path-21"/>
          <path
            d="M7.12589209,0 C3.19152982,0 0,3.19065552 0,7.12598007 L0,7.12598007 L0,66.8749336 C0,70.8093445 3.19152982,74 7.12589209,74 L7.12589209,74 L66.8741079,74 C70.8093839,74 74,70.8093445 74,66.8749336 L74,66.8749336 L74,7.12598007 C74,3.19065552 70.8093839,0 66.8741079,0 L66.8741079,0 L7.12589209,0 Z"
            id="path-23"/>
          <path
            d="M7.12589209,0 C3.19152982,0 0,3.19065552 0,7.12598007 L0,7.12598007 L0,66.8749336 C0,70.8093445 3.19152982,74 7.12589209,74 L7.12589209,74 L66.8741079,74 C70.8093839,74 74,70.8093445 74,66.8749336 L74,66.8749336 L74,7.12598007 C74,3.19065552 70.8093839,0 66.8741079,0 L66.8741079,0 L7.12589209,0 Z"
            id="path-25"/>
          <path
            d="M7.12589209,0 C3.19152982,0 0,3.1897812 0,7.12515434 L0,7.12515434 L0,66.8748457 C0,70.8102188 3.19152982,74 7.12589209,74 L7.12589209,74 L66.8741079,74 C70.8093839,74 74,70.8102188 74,66.8748457 L74,66.8748457 L74,7.12515434 C74,3.1897812 70.8093839,0 66.8741079,0 L66.8741079,0 L7.12589209,0 Z"
            id="path-27"/>
          <path
            d="M7.12589209,0 C3.19152982,0 0,3.1897812 0,7.12515434 L0,7.12515434 L0,66.8748457 C0,70.8102188 3.19152982,74 7.12589209,74 L7.12589209,74 L66.8741079,74 C70.8093839,74 74,70.8102188 74,66.8748457 L74,66.8748457 L74,7.12515434 C74,3.1897812 70.8093839,0 66.8741079,0 L66.8741079,0 L7.12589209,0 Z"
            id="path-29"/>
          <path
            d="M7.12589209,0 C3.19152982,0 0,3.1897812 0,7.12515434 L0,7.12515434 L0,66.8748457 C0,70.8102188 3.19152982,74 7.12589209,74 L7.12589209,74 L66.8741079,74 C70.8093839,74 74,70.8102188 74,66.8748457 L74,66.8748457 L74,7.12515434 C74,3.1897812 70.8093839,0 66.8741079,0 L66.8741079,0 L7.12589209,0 Z"
            id="path-31"/>
          <path
            d="M7.12589209,0 C3.19152982,0 0,3.1897812 0,7.12515434 L0,7.12515434 L0,66.8748457 C0,70.8102188 3.19152982,74 7.12589209,74 L7.12589209,74 L66.8741079,74 C70.8093839,74 74,70.8102188 74,66.8748457 L74,66.8748457 L74,7.12515434 C74,3.1897812 70.8093839,0 66.8741079,0 L66.8741079,0 L7.12589209,0 Z"
            id="path-33"/>
          <polygon id="path-35" points="0 1.28237669 0 9 10 9 10 0"/>
          <path
            d="M8.66660081,0 C3.87987751,0 0,3.8805749 0,8.66617277 L0,8.66617277 L0,9.33382723 C0,14.1203141 3.87987751,18 8.66660081,18 L8.66660081,18 L9.33339919,18 C14.1201225,18 18,14.1203141 18,9.33382723 L18,9.33382723 L18,8.66617277 C18,3.8805749 14.1201225,0 9.33339919,0 L9.33339919,0 L8.66660081,0 Z"
            id="path-37"/>
          <path
            d="M8.66660081,0 C3.87987751,0 0,3.87949427 0,8.66574476 L0,8.66574476 L0,9.33336626 C0,14.1187278 3.87987751,18 8.66660081,18 L8.66660081,18 L9.33339919,18 C14.1201225,18 18,14.1187278 18,9.33336626 L18,9.33336626 L18,8.66574476 C18,3.87949427 14.1201225,0 9.33339919,0 L9.33339919,0 L8.66660081,0 Z"
            id="path-39"/>
          <path
            d="M8.66706179,0 C3.8805749,0 0,3.8805749 0,8.66617277 L0,8.66617277 L0,9.33382723 C0,14.1203141 3.8805749,18 8.66706179,18 L8.66706179,18 L9.33382723,18 C14.1203141,18 18,14.1203141 18,9.33382723 L18,9.33382723 L18,8.66617277 C18,3.8805749 14.1203141,0 9.33382723,0 L9.33382723,0 L8.66706179,0 Z"
            id="path-41"/>
          <path
            d="M8.66706179,0 C3.8805749,0 0,3.87949427 0,8.66574476 L0,8.66574476 L0,9.33336626 C0,14.1187278 3.8805749,18 8.66706179,18 L8.66706179,18 L9.33382723,18 C14.1203141,18 18,14.1187278 18,9.33336626 L18,9.33336626 L18,8.66574476 C18,3.87949427 14.1203141,0 9.33382723,0 L9.33382723,0 L8.66706179,0 Z"
            id="path-43"/>
          <path
            d="M3.42831339,0.571686611 L3.42831339,3.42831339 L0.571686611,3.42831339 C0.255588169,3.42831339 0,3.6848047 0,4 L0,4 C0,4.3151953 0.255588169,4.57168661 0.571686611,4.57168661 L0.571686611,4.57168661 L3.42831339,4.57168661 L3.42831339,7.42831339 C3.42831339,7.74350869 3.6848047,8 4,8 L4,8 C4.3151953,8 4.57168661,7.74350869 4.57168661,7.42831339 L4.57168661,7.42831339 L4.57168661,4.57168661 L7.42831339,4.57168661 C7.74350869,4.57168661 8,4.3151953 8,4 L8,4 C8,3.6848047 7.74350869,3.42831339 7.42831339,3.42831339 L7.42831339,3.42831339 L4.57168661,3.42831339 L4.57168661,0.571686611 C4.57168661,0.255588169 4.3151953,0 4,0 L4,0 C3.6848047,0 3.42831339,0.255588169 3.42831339,0.571686611 L3.42831339,0.571686611 Z"
            id="path-45"/>
          <path
            d="M3.42831339,0.571686611 L3.42831339,3.42831339 L0.571686611,3.42831339 C0.255588169,3.42831339 0,3.6848047 0,4 L0,4 C0,4.3151953 0.255588169,4.57168661 0.571686611,4.57168661 L0.571686611,4.57168661 L3.42831339,4.57168661 L3.42831339,7.42831339 C3.42831339,7.74350869 3.6848047,8 4,8 L4,8 C4.3151953,8 4.57168661,7.74350869 4.57168661,7.42831339 L4.57168661,7.42831339 L4.57168661,4.57168661 L7.42831339,4.57168661 C7.74350869,4.57168661 8,4.3151953 8,4 L8,4 C8,3.6848047 7.74350869,3.42831339 7.42831339,3.42831339 L7.42831339,3.42831339 L4.57168661,3.42831339 L4.57168661,0.571686611 C4.57168661,0.255588169 4.3151953,0 4,0 L4,0 C3.6848047,0 3.42831339,0.255588169 3.42831339,0.571686611 L3.42831339,0.571686611 Z"
            id="path-47"/>
          <path
            d="M3.42831339,0.571686611 L3.42831339,3.42921653 L0.571686611,3.42921653 C0.255588169,3.42921653 0,3.6848047 0,4 L0,4 C0,4.31609844 0.255588169,4.57168661 0.571686611,4.57168661 L0.571686611,4.57168661 L3.42831339,4.57168661 L3.42831339,7.43011967 C3.42831339,7.74441183 3.6848047,8 4,8 L4,8 C4.3151953,8 4.57168661,7.74441183 4.57168661,7.43011967 L4.57168661,7.43011967 L4.57168661,4.57168661 L7.42831339,4.57168661 C7.74350869,4.57168661 8,4.31609844 8,4 L8,4 C8,3.6848047 7.74350869,3.42921653 7.42831339,3.42921653 L7.42831339,3.42921653 L4.57168661,3.42921653 L4.57168661,0.571686611 C4.57168661,0.256491307 4.3151953,0 4,0 L4,0 C3.6848047,0 3.42831339,0.256491307 3.42831339,0.571686611 L3.42831339,0.571686611 Z"
            id="path-49"/>
          <path
            d="M3.42831339,0.571686611 L3.42831339,3.42921653 L0.571686611,3.42921653 C0.255588169,3.42921653 0,3.6848047 0,4 L0,4 C0,4.31609844 0.255588169,4.57168661 0.571686611,4.57168661 L0.571686611,4.57168661 L3.42831339,4.57168661 L3.42831339,7.43011967 C3.42831339,7.74441183 3.6848047,8 4,8 L4,8 C4.3151953,8 4.57168661,7.74441183 4.57168661,7.43011967 L4.57168661,7.43011967 L4.57168661,4.57168661 L7.42831339,4.57168661 C7.74350869,4.57168661 8,4.31609844 8,4 L8,4 C8,3.6848047 7.74350869,3.42921653 7.42831339,3.42921653 L7.42831339,3.42921653 L4.57168661,3.42921653 L4.57168661,0.571686611 C4.57168661,0.256491307 4.3151953,0 4,0 L4,0 C3.6848047,0 3.42831339,0.256491307 3.42831339,0.571686611 L3.42831339,0.571686611 Z"
            id="path-51"/>
          <polygon id="path-53" points="0 2.04960488 0 12 13 12 13 0"/>
          <polygon id="path-55" points="0 0 0 8.55890202 10 10 10 0"/>
          <polygon id="path-57" points="0 0 0 9.92667743 13 12 13 0"/>
        </defs>
        <g id="Settings-page" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="Artboard" transform="translate(-373.000000, -152.000000)">
            <g id="Group-5" transform="translate(373.000000, 152.000000)">
              <g id="Group-135">
                <g id="Group-3" transform="translate(23.000000, 7.000000)">
                  <mask id="mask-2" fill="white">
                    <use xlink:href="#path-1"/>
                  </mask>
                  <g id="Clip-2"/>
                  <polygon id="Fill-1" fill="#F6F6F6" mask="url(#mask-2)"
                    points="-0.924035901 77.9508818 61.9281625 77.9508818 61.9281625 -3.582769 -0.924035901 -3.582769"/>
                </g>
                <g id="Group-6" transform="translate(67.000000, 0.000000)">
                  <mask id="mask-4" fill="white">
                    <use xlink:href="#path-3"/>
                  </mask>
                  <g id="Clip-5"/>
                  <polygon id="Fill-4" fill="#F6F6F6" mask="url(#mask-4)"
                    points="-5.44311415 179.872566 214.454648 179.872566 214.454648 -5.38666948 -5.44311415 -5.38666948"/>
                </g>
                <g id="Group-9" transform="translate(173.000000, 148.000000)">
                  <mask id="mask-6" fill="white">
                    <use xlink:href="#path-5"/>
                  </mask>
                  <g id="Clip-8"/>
                  <polygon id="Fill-7" fill="#F6F6F6" mask="url(#mask-6)"
                    points="-3.9087889 38.3238543 85.428901 38.3238543 85.428901 -3.56073863 -3.9087889 -3.56073863"/>
                </g>
                <g id="Group-12" transform="translate(42.000000, 123.000000)">
                  <mask id="mask-8" fill="white">
                    <use xlink:href="#path-7"/>
                  </mask>
                  <g id="Clip-11"/>
                  <polygon id="Fill-10" fill="#EAEBEE" mask="url(#mask-8)"
                    points="-0.887271849 25.8755388 83.8881828 25.8755388 83.8881828 -0.875538793 -0.887271849 -0.875538793"/>
                </g>
                <polygon id="Fill-13" fill="#D4D4D4" points="0 97 286 97 286 95 0 95"/>
                <g id="Group-20" transform="translate(46.000000, 13.000000)">
                  <g id="Group-16">
                    <mask id="mask-10" fill="white">
                      <use xlink:href="#path-9"/>
                    </mask>
                    <g id="Clip-15"/>
                    <polygon id="Fill-14" fill="#FFFFFF" mask="url(#mask-10)"
                      points="-0.889937029 74.889948 74.889937 74.889948 74.889937 -0.890861722 -0.889937029 -0.890861722"/>
                  </g>
                  <g id="Group-19" transform="translate(0.000000, 0.000000)">
                    <mask id="mask-12" fill="white">
                      <use xlink:href="#path-11"/>
                    </mask>
                    <g id="Clip-18"/>
                    <path
                      d="M7.12625756,0.000274111299 L66.8744734,0.000274111299 C70.8097494,0.000274111299 73.9994518,3.19092963 73.9994518,7.12625418 L73.9994518,66.874294 C73.9994518,70.8096186 70.8097494,74.0002741 66.8744734,74.0002741 L7.12625756,74.0002741 C3.1909816,74.0002741 0.000365477219,70.8096186 0.000365477219,66.874294 L0.000365477219,7.12625418 C0.000365477219,3.19092963 3.1909816,0.000274111299 7.12625756,0.000274111299 Z"
                      id="Stroke-17" stroke="#AEB3BB" stroke-width="4" stroke-linecap="round"
                      stroke-linejoin="round" mask="url(#mask-12)"/>
                  </g>
                </g>
                <g id="Group-27" transform="translate(46.000000, 105.000000)">
                  <g id="Group-23">
                    <mask id="mask-14" fill="white">
                      <use xlink:href="#path-13"/>
                    </mask>
                    <g id="Clip-22"/>
                    <polygon id="Fill-21" fill="#FFFFFF" mask="url(#mask-14)"
                      points="-0.889937029 74.889959 74.889937 74.889959 74.889937 -0.891786437 -0.889937029 -0.891786437"/>
                  </g>
                  <g id="Group-26">
                    <mask id="mask-16" fill="white">
                      <use xlink:href="#path-15"/>
                    </mask>
                    <g id="Clip-25"/>
                    <text id="CMD" mask="url(#mask-16)" font-size="14" font-weight="400"
                      line-spacing="17" fill="#6F7786">
                      <tspan x="19.784" y="41">CMD</tspan>
                    </text>
                    <path
                      d="M7.12616619,-0.000639600929 L66.874382,-0.000639600929 C70.809658,-0.000639600929 73.9993604,3.19005532 73.9993604,7.12542846 L73.9993604,66.8742061 C73.9993604,70.8095792 70.809658,74.0002741 66.874382,74.0002741 L7.12616619,74.0002741 C3.19089023,74.0002741 0.000274107915,70.8095792 0.000274107915,66.8742061 L0.000274107915,7.12542846 C0.000274107915,3.19005532 3.19089023,-0.000639600929 7.12616619,-0.000639600929 Z"
                      id="Stroke-24" stroke="#AEB3BB" stroke-width="4" stroke-linecap="round"
                      stroke-linejoin="round" mask="url(#mask-16)"/>
                  </g>
                </g>
                <g id="Group-34" transform="translate(127.000000, 13.000000)">
                  <g id="Group-30">
                    <mask id="mask-18" fill="white">
                      <use xlink:href="#path-17"/>
                    </mask>
                    <g id="Clip-29"/>
                    <polygon id="Fill-28" fill="#FFFFFF" mask="url(#mask-18)"
                      points="-0.889937029 74.889948 74.889937 74.889948 74.889937 -0.890861722 -0.889937029 -0.890861722"/>
                  </g>
                  <g id="Group-33" transform="translate(0.000000, 0.000000)">
                    <mask id="mask-20" fill="white">
                      <use xlink:href="#path-19"/>
                    </mask>
                    <g id="Clip-32"/>
                    <path
                      d="M7.12616619,0.000274111299 L66.874382,0.000274111299 C70.809658,0.000274111299 73.9993604,3.19092963 73.9993604,7.12625418 L73.9993604,66.874294 C73.9993604,70.8096186 70.809658,74.0002741 66.874382,74.0002741 L7.12616619,74.0002741 C3.19089023,74.0002741 0.000274107915,70.8096186 0.000274107915,66.874294 L0.000274107915,7.12625418 C0.000274107915,3.19092963 3.19089023,0.000274111299 7.12616619,0.000274111299 Z"
                      id="Stroke-31" stroke="#AEB3BB" stroke-width="4" stroke-linecap="round"
                      stroke-linejoin="round" mask="url(#mask-20)"/>
                  </g>
                </g>
                <g id="Group-37" transform="translate(6.000000, 127.000000)">
                  <mask id="mask-22" fill="white">
                    <use xlink:href="#path-21"/>
                  </mask>
                  <g id="Clip-36"/>
                  <polygon id="Fill-35" fill="#344055" mask="url(#mask-22)"
                    points="-0.903889606 27.9273571 23.9048176 27.9273571 23.9048176 -0.89478404 -0.903889606 -0.89478404"/>
                </g>
                <g id="Group-44" transform="translate(209.000000, 13.000000)">
                  <g id="Group-40">
                    <mask id="mask-24" fill="white">
                      <use xlink:href="#path-23"/>
                    </mask>
                    <g id="Clip-39"/>
                    <polygon id="Fill-38" fill="#FFFFFF" mask="url(#mask-24)"
                      points="-0.889937029 74.889948 74.889937 74.889948 74.889937 -0.890861722 -0.889937029 -0.890861722"/>
                  </g>
                  <g id="Group-43" transform="translate(0.000000, 0.000000)">
                    <mask id="mask-26" fill="white">
                      <use xlink:href="#path-25"/>
                    </mask>
                    <g id="Clip-42"/>
                    <path
                      d="M7.12607482,0.000274111299 L66.8742907,0.000274111299 C70.8095666,0.000274111299 73.999269,3.19092963 73.999269,7.12625418 L73.999269,66.874294 C73.999269,70.8096186 70.8095666,74.0002741 66.8742907,74.0002741 L7.12607482,74.0002741 C3.19079886,74.0002741 0.00018273861,70.8096186 0.00018273861,66.874294 L0.00018273861,7.12625418 C0.00018273861,3.19092963 3.19079886,0.000274111299 7.12607482,0.000274111299 Z"
                      id="Stroke-41" stroke="#AEB3BB" stroke-width="4" stroke-linecap="round"
                      stroke-linejoin="round" mask="url(#mask-26)"/>
                  </g>
                </g>
                <g id="Group-65" transform="translate(62.000000, 42.000000)" fill="#6F7786">
                  <path
                    d="M0,7.86694275 L0,7.83739437 C0,4.8852426 2.24522762,2.46675248 5.43983459,2.46675248 C7.06669251,2.46675248 8.13701771,2.94131737 9.05638795,3.63883821 C9.25190189,3.78658011 9.41831609,4.03908445 9.41831609,4.36590744 C9.41831609,4.87002071 9.01091959,5.25594046 8.49894585,5.25594046 C8.2425043,5.25594046 8.06154023,5.16639991 7.94059439,5.07775477 C7.21764747,4.49932285 6.43468231,4.14295148 5.42437535,4.14295148 C3.42013004,4.14295148 1.94422707,5.77527562 1.94422707,7.80784599 L1.94422707,7.83739437 C1.94422707,9.86996474 3.40558016,11.5166154 5.42437535,11.5166154 C6.5401689,11.5166154 7.29312494,11.1611394 8.06154023,10.5227153 C8.19703594,10.4045218 8.39345926,10.3149813 8.61898232,10.3149813 C9.08639706,10.3149813 9.4928842,10.700901 9.4928842,11.1611394 C9.4928842,11.4431921 9.35738849,11.6652527 9.19188366,11.81389 C8.19703594,12.6743746 7.06669251,13.2089317 5.36435711,13.2089317 C2.28978661,13.2089317 0,10.8495383 0,7.86694275"
                    id="Fill-45"/>
                  <path
                    d="M14.1795809,4.33591135 L11.6178935,4.33591135 C11.1359289,4.33591135 10.7594508,3.94999161 10.7594508,3.49064861 C10.7594508,3.03041021 11.1359289,2.64449046 11.6178935,2.64449046 L18.6245678,2.64449046 C19.0919825,2.64449046 19.4693699,3.03041021 19.4693699,3.49064861 C19.4693699,3.94999161 19.0919825,4.33591135 18.6245678,4.33591135 L16.0483305,4.33591135 L16.0483305,12.199362 C16.0483305,12.7043707 15.6263841,13.1046169 15.1144104,13.1046169 C14.6024366,13.1046169 14.1795809,12.7043707 14.1795809,12.199362 L14.1795809,4.33591135 Z"
                    id="Fill-47"/>
                  <path
                    d="M25.920148,7.79280318 C27.245096,7.79280318 28.0898981,7.11050423 28.0898981,6.05661201 L28.0898981,6.02706363 C28.0898981,4.91497006 27.2760145,4.30609435 25.9046887,4.30609435 L23.2075056,4.30609435 L23.2075056,7.79280318 L25.920148,7.79280318 Z M21.3542153,3.56469864 C21.3542153,3.04536348 21.7616118,2.64422184 22.2881354,2.64422184 L26.0547343,2.64422184 C27.3815011,2.64422184 28.4209078,3.03014159 29.0992957,3.68289216 C29.6567378,4.24699759 29.9731976,5.01794169 29.9731976,5.9231966 L29.9731976,5.95274498 C29.9731976,7.61461749 28.9938091,8.62373944 27.577015,9.05353405 L29.5967196,11.5615647 C29.7776837,11.7845207 29.8977201,11.9770329 29.8977201,12.2590856 C29.8977201,12.7631988 29.4612239,13.1043483 29.0092684,13.1043483 C28.587322,13.1043483 28.3154212,12.9118361 28.1053574,12.6297834 L25.5427606,9.40990542 L23.2075056,9.40990542 L23.2075056,12.1990934 C23.2075056,12.7041021 22.8010185,13.1043483 22.2881354,13.1043483 C21.7616118,13.1043483 21.3542153,12.7041021 21.3542153,12.1990934 L21.3542153,3.56469864 Z"
                    id="Fill-49"/>
                  <path
                    d="M32.2500712,3.47533718 C32.2500712,2.9703285 32.6565583,2.57008227 33.1839913,2.57008227 C33.6968744,2.57008227 34.1033615,2.9703285 34.1033615,3.47533718 L34.1033615,11.3683362 L38.8793581,11.3683362 C39.3467728,11.3683362 39.7232508,11.7390341 39.7232508,12.1992725 C39.7232508,12.6595109 39.3467728,13.0302087 38.8793581,13.0302087 L33.1839913,13.0302087 C32.6565583,13.0302087 32.2500712,12.6299625 32.2500712,12.1106273 L32.2500712,3.47533718 Z"
                    id="Fill-51"/>
                  <path
                    d="M80.8418347,11.8732554 C80.6308615,11.7246181 80.4808159,11.4730091 80.4808159,11.1757345 C80.4808159,10.7011696 80.8718438,10.3295764 81.3547178,10.3295764 C81.6111594,10.3295764 81.7766642,10.403895 81.8967007,10.4934356 C82.7706026,11.1757345 83.705432,11.5616543 84.8503253,11.5616543 C85.996128,11.5616543 86.7181656,11.0270972 86.7181656,10.2561531 L86.7181656,10.2257093 C86.7181656,9.48431362 86.2971286,9.08406738 84.3383516,8.63905087 C82.093124,8.10449382 80.8272848,7.45174324 80.8272848,5.53736639 L80.8272848,5.50781801 C80.8272848,3.72775197 82.3341063,2.49567407 84.428379,2.49567407 C85.7542363,2.49567407 86.8245615,2.83771895 87.7739409,3.46092115 C87.9849141,3.57911467 88.180428,3.831619 88.180428,4.18799037 C88.180428,4.66255526 87.7884908,5.03325312 87.3065261,5.03325312 C87.1255621,5.03325312 86.9746071,4.98848285 86.8245615,4.89983771 C86.0106779,4.38050255 85.2268034,4.11367172 84.3983698,4.11367172 C83.3134948,4.11367172 82.6805752,4.66255526 82.6805752,5.34485422 L82.6805752,5.3744026 C82.6805752,6.17579048 83.1634492,6.53126644 85.1967942,7.00672673 C87.427472,7.54038838 88.5723653,8.32655437 88.5723653,10.048419 L88.5723653,10.0779674 C88.5723653,12.0218927 87.0209848,13.1787565 84.8057663,13.1787565 C83.373513,13.1787565 82.0176465,12.73374 80.8418347,11.8732554"
                    id="Fill-53"/>
                  <path
                    d="M90.7587568,3.47533718 C90.7587568,2.9703285 91.165244,2.57008227 91.692677,2.57008227 C92.2055601,2.57008227 92.6120472,2.9703285 92.6120472,3.47533718 L92.6120472,6.962046 L97.6444853,6.962046 L97.6444853,3.47533718 C97.6444853,2.9703285 98.0509724,2.57008227 98.5638555,2.57008227 C99.0912885,2.57008227 99.4977756,2.9703285 99.4977756,3.47533718 L99.4977756,12.1992725 C99.4977756,12.7042812 99.0912885,13.1045274 98.5638555,13.1045274 C98.0509724,13.1045274 97.6444853,12.7042812 97.6444853,12.1992725 L97.6444853,8.6534669 L92.6120472,8.6534669 L92.6120472,12.1992725 C92.6120472,12.7042812 92.2055601,13.1045274 91.692677,13.1045274 C91.165244,13.1045274 90.7587568,12.7042812 90.7587568,12.1992725 L90.7587568,3.47533718 Z"
                    id="Fill-55"/>
                  <path
                    d="M102.316632,3.47533718 C102.316632,2.9703285 102.723119,2.57008227 103.251462,2.57008227 C103.763435,2.57008227 104.169922,2.9703285 104.169922,3.47533718 L104.169922,12.1992725 C104.169922,12.7042812 103.763435,13.1045274 103.251462,13.1045274 C102.723119,13.1045274 102.316632,12.7042812 102.316632,12.1992725 L102.316632,3.47533718 Z"
                    id="Fill-57"/>
                  <path
                    d="M106.988779,3.56443002 C106.988779,3.04509486 107.395266,2.64395322 107.922699,2.64395322 L114.070931,2.64395322 C114.537436,2.64395322 114.913914,3.01554648 114.913914,3.47578488 C114.913914,3.93512788 114.537436,4.30582573 114.070931,4.30582573 L108.842069,4.30582573 L108.842069,7.13978398 L113.392543,7.13978398 C113.859957,7.13978398 114.236435,7.51137725 114.236435,7.97072024 C114.236435,8.43095864 113.859957,8.8016565 113.392543,8.8016565 L108.842069,8.8016565 L108.842069,12.1988248 C108.842069,12.7038335 108.435582,13.1040797 107.922699,13.1040797 C107.395266,13.1040797 106.988779,12.7038335 106.988779,12.1988248 L106.988779,3.56443002 Z"
                    id="Fill-59"/>
                  <path
                    d="M119.465933,4.33591135 L116.904246,4.33591135 C116.422281,4.33591135 116.045803,3.94999161 116.045803,3.49064861 C116.045803,3.03041021 116.422281,2.64449046 116.904246,2.64449046 L123.91092,2.64449046 C124.378335,2.64449046 124.755722,3.03041021 124.755722,3.49064861 C124.755722,3.94999161 124.378335,4.33591135 123.91092,4.33591135 L121.334683,4.33591135 L121.334683,12.199362 C121.334683,12.7043707 120.912737,13.1046169 120.400763,13.1046169 C119.888789,13.1046169 119.465933,12.7043707 119.465933,12.199362 L119.465933,4.33591135 Z"
                    id="Fill-61"/>
                  <path
                    d="M183.799934,7.87509094 C185.827823,7.87509094 187.119125,6.83104818 187.119125,5.21931837 L187.119125,5.1745481 C187.119125,3.47238234 185.874201,2.54205607 183.7772,2.54205607 L179.651401,2.54205607 L179.651401,7.87509094 L183.799934,7.87509094 Z M176.815994,1.40668196 C176.815994,0.612457328 177.438911,0 178.24552,0 L184.00727,0 C186.036068,0 187.626552,0.590072192 188.66323,1.58844927 C189.516217,2.45072472 190,3.6308691 190,5.01516593 L190,5.06083161 C190,7.60288768 188.502272,9.14567127 186.33525,9.80379428 L189.424371,13.6397112 C189.700818,13.9799653 189.88451,14.2745537 189.88451,14.7061391 C189.88451,15.4779786 189.216125,16 188.525006,16 C187.880265,16 187.464684,15.7045162 187.142768,15.2738262 L183.224305,10.3490962 L179.651401,10.3490962 L179.651401,14.6157032 C179.651401,15.3866473 179.029394,16 178.24552,16 C177.438911,16 176.815994,15.3866473 176.815994,14.6157032 L176.815994,1.40668196 Z"
                    id="Fill-63"/>
                </g>
                <g id="Group" transform="translate(96.000000, 105.000000)">
                  <g id="Group-72" transform="translate(31.000000, 0.000000)">
                    <g id="Group-68">
                      <mask id="mask-28" fill="white">
                        <use xlink:href="#path-27"/>
                      </mask>
                      <g id="Clip-67"/>
                      <polygon id="Fill-66" fill="#FFFFFF" mask="url(#mask-28)"
                        points="-0.889937029 74.889959 74.889937 74.889959 74.889937 -0.891786437 -0.889937029 -0.891786437"/>
                    </g>
                    <g id="Group-71">
                      <mask id="mask-30" fill="white">
                        <use xlink:href="#path-29"/>
                      </mask>
                      <g id="Clip-70"/>
                      <path
                        d="M7.12625756,-0.000639600928 L66.8744734,-0.000639600928 C70.8097494,-0.000639600928 73.9994518,3.19005532 73.9994518,7.12542846 L73.9994518,66.8742061 C73.9994518,70.8095792 70.8097494,74.0002741 66.8744734,74.0002741 L7.12625756,74.0002741 C3.1909816,74.0002741 0.000365477219,70.8095792 0.000365477219,66.8742061 L0.000365477219,7.12542846 C0.000365477219,3.19005532 3.1909816,-0.000639600928 7.12625756,-0.000639600928 Z"
                        id="Stroke-69" stroke="#AEB3BB" stroke-width="4" stroke-linecap="round"
                        stroke-linejoin="round" mask="url(#mask-30)"/>
                    </g>
                  </g>
                  <g id="Group-83" transform="translate(0.000000, 7.000000)" fill="#6F7786">
                    <path
                      d="M46.3587801,34.6557707 C46.1491152,34.502724 46,34.243651 46,33.9375576 C46,33.4489146 46.3886032,33.0672198 46.8684829,33.0672198 C47.1224305,33.0672198 47.2878128,33.1437432 47.4071049,33.235018 C48.2755878,33.9375576 49.2046205,34.3358478 50.3424144,34.3358478 C51.4802084,34.3358478 52.1986723,33.7854329 52.1986723,32.9906965 L52.1986723,32.9602716 C52.1986723,32.1968821 51.7802461,31.7838404 49.8336154,31.3256223 C47.6023103,30.7752074 46.3443205,30.1030928 46.3443205,28.1328472 L46.3443205,28.1024223 C46.3443205,26.2686279 47.8417983,25 49.9230845,25 C51.2407204,25 52.3044086,25.3521918 53.2469972,25.9938815 C53.4575658,26.1155813 53.6518674,26.3755762 53.6518674,26.7425195 C53.6518674,27.2311625 53.2623605,27.6128573 52.7833845,27.6128573 C52.6035426,27.6128573 52.4535237,27.5676808 52.3044086,27.475484 C51.4955717,26.9407426 50.7165579,26.6659961 49.8932615,26.6659961 C48.8151136,26.6659961 48.1861187,27.2311625 48.1861187,27.9337021 L48.1861187,27.9641271 C48.1861187,28.7892884 48.6650947,29.1562317 50.6867349,29.6448747 C52.9035804,30.1943676 54.0413743,31.0047775 54.0413743,32.7767999 L54.0413743,32.8072249 C54.0413743,34.8088174 52.4987101,36 50.297228,36 C48.8747597,36 47.5273008,35.5417819 46.3587801,34.6557707"
                      id="Fill-73"/>
                    <path
                      d="M56.2138468,26.0087252 C56.2138468,25.4887352 56.6178133,25.0766155 57.1419757,25.0766155 C57.6516785,25.0766155 58.055645,25.4887352 58.055645,26.0087252 L58.055645,29.5997905 L63.0568774,29.5997905 L63.0568774,26.0087252 C63.0568774,25.4887352 63.4608439,25.0766155 63.9705467,25.0766155 C64.4947091,25.0766155 64.8986756,25.4887352 64.8986756,26.0087252 L64.8986756,34.9914592 C64.8986756,35.5114492 64.4947091,35.9235689 63.9705467,35.9235689 C63.4608439,35.9235689 63.0568774,35.5114492 63.0568774,34.9914592 L63.0568774,31.340466 L58.055645,31.340466 L58.055645,34.9914592 C58.055645,35.5114492 57.6516785,35.9235689 57.1419757,35.9235689 C56.6178133,35.9235689 56.2138468,35.5114492 56.2138468,34.9914592 L56.2138468,26.0087252 Z"
                      id="Fill-75"/>
                    <path
                      d="M13.5,5 C14.3284795,5 15,4.32836579 15,3.49974598 C15,2.67163421 14.3284795,2 13.5,2 C12.6715205,2 12,2.67163421 12,3.49974598 L12,5 L13.5,5 Z M5,3.49974598 C5,2.67163421 4.32836579,2 3.50025402,2 C2.67163421,2 2,2.67163421 2,3.49974598 C2,4.32836579 2.67163421,5 3.50025402,5 L5,5 L5,3.49974598 L5,3.49974598 Z M3.50025402,12 C2.67163421,12 2,12.6716342 2,13.500254 C2,14.3288738 2.67163421,15 3.50025402,15 C4.32836579,15 5,14.3288738 5,13.500254 L5,12 L3.50025402,12 L3.50025402,12 Z M7,10 L10,10 L10,7 L7,7 L7,10 Z M12,13.500254 C12,14.3288738 12.6715205,15 13.5,15 C14.3284795,15 15,14.3288738 15,13.500254 C15,12.6716342 14.3284795,12 13.5,12 L12,12 L12,13.500254 L12,13.500254 Z M3.40046061,0 C5.27802615,0 6.80034546,1.52231931 6.80034546,3.39988485 L6.80034546,5.10011515 L10.2002303,5.10011515 L10.2002303,3.39988485 C10.2002303,1.52231931 11.7225496,0 13.6001152,0 C15.4776807,0 17,1.52231931 17,3.39988485 C17,5.27802615 15.4776807,6.80034546 13.6001152,6.80034546 L11.8998848,6.80034546 L11.8998848,10.2002303 L13.6001152,10.2002303 C15.4776807,10.2002303 17,11.7225496 17,13.6001152 C17,15.4776807 15.4776807,17 13.6001152,17 C11.7225496,17 10.2002303,15.4776807 10.2002303,13.6001152 L10.2002303,11.8998848 L6.80034546,11.8998848 L6.80034546,13.6001152 C6.80034546,15.4776807 5.27802615,17 3.40046061,17 C1.52231931,17 0,15.4776807 0,13.6001152 C0,11.7225496 1.52231931,10.2002303 3.40046061,10.2002303 L5.10011515,10.2002303 L5.10011515,6.80034546 L3.40046061,6.80034546 C1.52231931,6.80034546 0,5.27802615 0,3.39988485 C0,1.52231931 1.52231931,0 3.40046061,0 L3.40046061,0 Z"
                      id="Fill-133" opacity="0.300000012"/>
                    <path
                      d="M67.7000526,26.0087252 C67.7000526,25.4887352 68.1040191,25.0766155 68.6290853,25.0766155 C69.1378843,25.0766155 69.5418508,25.4887352 69.5418508,26.0087252 L69.5418508,34.9914592 C69.5418508,35.5114492 69.1378843,35.9235689 68.6290853,35.9235689 C68.1040191,35.9235689 67.7000526,35.5114492 67.7000526,34.9914592 L67.7000526,26.0087252 Z"
                      id="Fill-77"/>
                    <path
                      d="M72.3431374,26.100922 C72.3431374,25.5652586 72.747104,25.1531389 73.2712664,25.1531389 L79.3813733,25.1531389 C79.844986,25.1531389 80.2191295,25.5357556 80.2191295,26.0087252 C80.2191295,26.4826167 79.844986,26.8643115 79.3813733,26.8643115 L74.1849357,26.8643115 L74.1849357,29.7823401 L78.707192,29.7823401 C79.1717084,29.7823401 79.5458519,30.1649568 79.5458519,30.6379264 C79.5458519,31.111818 79.1717084,31.4935127 78.707192,31.4935127 L74.1849357,31.4935127 L74.1849357,34.9914592 C74.1849357,35.5114492 73.7809691,35.9235689 73.2712664,35.9235689 C72.747104,35.9235689 72.3431374,35.5114492 72.3431374,34.9914592 L72.3431374,26.100922 Z"
                      id="Fill-79"/>
                    <path
                      d="M84.7430125,26.8951974 L82.1972099,26.8951974 C81.718234,26.8951974 81.3440904,26.4978292 81.3440904,26.0248596 C81.3440904,25.5509681 81.718234,25.1526779 82.1972099,25.1526779 L89.1604364,25.1526779 C89.6249528,25.1526779 90,25.5509681 90,26.0248596 C90,26.4978292 89.6249528,26.8951974 89.1604364,26.8951974 L86.6001742,26.8951974 L86.6001742,34.9919202 C86.6001742,35.5119102 86.1808442,35.9240298 85.6720452,35.9240298 C85.1632462,35.9240298 84.7430125,35.5119102 84.7430125,34.9919202 L84.7430125,26.8951974 Z"
                      id="Fill-81"/>
                  </g>
                </g>
                <g id="Group-90" transform="translate(209.000000, 105.000000)">
                  <g id="Group-86">
                    <mask id="mask-32" fill="white">
                      <use xlink:href="#path-31"/>
                    </mask>
                    <g id="Clip-85"/>
                    <polygon id="Fill-84" fill="#FFFFFF" mask="url(#mask-32)"
                      points="-0.889937029 74.889959 74.889937 74.889959 74.889937 -0.891786437 -0.889937029 -0.891786437"/>
                  </g>
                  <g id="Group-89">
                    <mask id="mask-34" fill="white">
                      <use xlink:href="#path-33"/>
                    </mask>
                    <g id="Clip-88"/>
                    <path
                      d="M7.12607482,-0.000639600929 L66.8742907,-0.000639600929 C70.8095666,-0.000639600929 73.999269,3.19005532 73.999269,7.12542846 L73.999269,66.8742061 C73.999269,70.8095792 70.8095666,74.0002741 66.8742907,74.0002741 L7.12607482,74.0002741 C3.19079886,74.0002741 0.00018273861,70.8095792 0.00018273861,66.8742061 L0.00018273861,7.12542846 C0.00018273861,3.19005532 3.19079886,-0.000639600929 7.12607482,-0.000639600929 Z"
                      id="Stroke-87" stroke="#AEB3BB" stroke-width="4" stroke-linecap="round"
                      stroke-linejoin="round" mask="url(#mask-34)"/>
                  </g>
                </g>
                <path
                  d="M245.886467,141.875091 C247.886053,141.875091 249.159332,140.831048 249.159332,139.220214 L249.159332,139.174548 C249.159332,137.472382 247.931784,136.542056 245.86405,136.542056 L241.795834,136.542056 L241.795834,141.875091 L245.886467,141.875091 Z M239,135.406682 C239,134.612457 239.614223,134 240.409574,134 L246.090909,134 C248.091392,134 249.659677,134.590072 250.681887,135.588449 C251.522969,136.45162 252,137.630869 252,139.015166 L252,139.061727 C252,141.602888 250.523176,143.145671 248.386398,143.803794 L251.432404,147.639711 C251.704994,147.979965 251.886122,148.274554 251.886122,148.706139 C251.886122,149.478874 251.227066,150 250.545592,150 C249.90985,150 249.500069,149.705412 249.182646,149.273826 L245.318872,144.349096 L241.795834,144.349096 L241.795834,148.615703 C241.795834,149.387543 241.182508,150 240.409574,150 C239.614223,150 239,149.387543 239,148.615703 L239,135.406682 Z"
                  id="Fill-91" fill="#6F7786"/>
                <g id="Group-95" transform="translate(5.000000, 40.000000)">
                  <mask id="mask-36" fill="white">
                    <use xlink:href="#path-35"/>
                  </mask>
                  <g id="Clip-94"/>
                </g>
                <g id="Group-99" transform="translate(114.000000, 41.000000)">
                  <mask id="mask-38" fill="white">
                    <use xlink:href="#path-37"/>
                  </mask>
                  <g id="Clip-97"/>
                  <polygon id="Fill-96" fill="#FFFFFF" mask="url(#mask-38)"
                    points="-1.31403734 19.2979701 19.4865159 19.2979701 19.4865159 -1.50155579 -1.31403734 -1.50155579"/>
                  <path
                    d="M8.66615628,8.89020596e-05 L9.33384372,8.89020596e-05 C14.120567,8.89020596e-05 18.0004445,3.87977478 18.0004445,8.66626167 L18.0004445,9.33391614 C18.0004445,14.120403 14.120567,18.0000889 9.33384372,18.0000889 L8.66615628,18.0000889 C3.87943297,18.0000889 -0.000444532253,14.120403 -0.000444532253,9.33391614 L-0.000444532253,8.66626167 C-0.000444532253,3.87977478 3.87943297,8.89020596e-05 8.66615628,8.89020596e-05 Z"
                    id="Stroke-98" fill="#66B2FF" mask="url(#mask-38)"/>
                </g>
                <g id="Group-103" transform="translate(114.000000, 133.000000)">
                  <mask id="mask-40" fill="white">
                    <use xlink:href="#path-39"/>
                  </mask>
                  <g id="Clip-101"/>
                  <polygon id="Fill-100" fill="#FFFFFF" mask="url(#mask-40)"
                    points="-1.31403734 19.4259186 19.4865159 19.4259186 19.4865159 -1.37258001 -1.31403734 -1.37258001"/>
                  <path
                    d="M8.66615628,8.8897669e-05 L9.33384372,8.8897669e-05 C14.120567,8.8897669e-05 18.0004445,3.87958317 18.0004445,8.66583366 L18.0004445,9.33345516 C18.0004445,14.1197056 14.120567,17.9991999 9.33384372,17.9991999 L8.66615628,17.9991999 C3.87943297,17.9991999 -0.000444532253,14.1197056 -0.000444532253,9.33345516 L-0.000444532253,8.66583366 C-0.000444532253,3.87958317 3.87943297,8.8897669e-05 8.66615628,8.8897669e-05 Z"
                    id="Stroke-102" fill="#344055" mask="url(#mask-40)"/>
                </g>
                <g id="Group-107" transform="translate(196.000000, 41.000000)">
                  <mask id="mask-42" fill="white">
                    <use xlink:href="#path-41"/>
                  </mask>
                  <g id="Clip-105"/>
                  <polygon id="Fill-104" fill="#FFFFFF" mask="url(#mask-42)"
                    points="-1.4588828 19.2979701 19.3406431 19.2979701 19.3406431 -1.50155579 -1.4588828 -1.50155579"/>
                  <path
                    d="M8.66643947,8.89020595e-05 L9.33409394,8.89020595e-05 C14.1205808,8.89020595e-05 18.0002667,3.87977478 18.0002667,8.66626167 L18.0002667,9.33391614 C18.0002667,14.120403 14.1205808,18.0000889 9.33409394,18.0000889 L8.66643947,18.0000889 C3.87995259,18.0000889 0.000266706179,14.120403 0.000266706179,9.33391614 L0.000266706179,8.66626167 C0.000266706179,3.87977478 3.87995259,8.89020595e-05 8.66643947,8.89020595e-05 Z"
                    id="Stroke-106" fill="#66B2FF" mask="url(#mask-42)"/>
                </g>
                <g id="Group-111" transform="translate(196.000000, 133.000000)">
                  <mask id="mask-44" fill="white">
                    <use xlink:href="#path-43"/>
                  </mask>
                  <g id="Clip-109"/>
                  <polygon id="Fill-108" fill="#FFFFFF" mask="url(#mask-44)"
                    points="-1.4588828 19.4259186 19.3406431 19.4259186 19.3406431 -1.37258001 -1.4588828 -1.37258001"/>
                  <path
                    d="M8.66643947,8.8897669e-05 L9.33409394,8.8897669e-05 C14.1205808,8.8897669e-05 18.0002667,3.87958317 18.0002667,8.66583366 L18.0002667,9.33345516 C18.0002667,14.1197056 14.1205808,17.9991999 9.33409394,17.9991999 L8.66643947,17.9991999 C3.87995259,17.9991999 0.000266706179,14.1197056 0.000266706179,9.33345516 L0.000266706179,8.66583366 C0.000266706179,3.87958317 3.87995259,8.8897669e-05 8.66643947,8.8897669e-05 Z"
                    id="Stroke-110" fill="#344055" mask="url(#mask-44)"/>
                </g>
                <g id="Group-114" transform="translate(201.000000, 46.000000)">
                  <mask id="mask-46" fill="white">
                    <use xlink:href="#path-45"/>
                  </mask>
                  <g id="Clip-113"/>
                  <polygon id="Fill-112" fill="#FFFFFF" mask="url(#mask-46)"
                    points="-0.880559946 8.88055995 8.88055995 8.88055995 8.88055995 -0.880559946 -0.880559946 -0.880559946"/>
                </g>
                <g id="Group-117" transform="translate(119.000000, 46.000000)">
                  <mask id="mask-48" fill="white">
                    <use xlink:href="#path-47"/>
                  </mask>
                  <g id="Clip-116"/>
                  <polygon id="Fill-115" fill="#FFFFFF" mask="url(#mask-48)"
                    points="-0.880559946 8.88055995 8.88055995 8.88055995 8.88055995 -0.880559946 -0.880559946 -0.880559946"/>
                </g>
                <g id="Group-120" transform="translate(119.000000, 138.000000)">
                  <mask id="mask-50" fill="white">
                    <use xlink:href="#path-49"/>
                  </mask>
                  <g id="Clip-119"/>
                  <polygon id="Fill-118" fill="#FFFFFF" mask="url(#mask-50)"
                    points="-0.880559946 8.88146308 8.88055995 8.88146308 8.88055995 -0.879656807 -0.880559946 -0.879656807"/>
                </g>
                <g id="Group-123" transform="translate(201.000000, 138.000000)">
                  <mask id="mask-52" fill="white">
                    <use xlink:href="#path-51"/>
                  </mask>
                  <g id="Clip-122"/>
                  <polygon id="Fill-121" fill="#FFFFFF" mask="url(#mask-52)"
                    points="-0.880559946 8.88146308 8.88055995 8.88146308 8.88055995 -0.879656807 -0.880559946 -0.879656807"/>
                </g>
                <g id="Group-126" transform="translate(17.000000, 38.000000)">
                  <mask id="mask-54" fill="white">
                    <use xlink:href="#path-53"/>
                  </mask>
                  <g id="Clip-125"/>
                </g>
                <g id="Group-129" transform="translate(5.000000, 51.000000)">
                  <mask id="mask-56" fill="white">
                    <use xlink:href="#path-55"/>
                  </mask>
                  <g id="Clip-128"/>
                </g>
                <g id="Group-132" transform="translate(17.000000, 51.000000)">
                  <mask id="mask-58" fill="white">
                    <use xlink:href="#path-57"/>
                  </mask>
                  <g id="Clip-131"/>
                </g>
              </g>
              <g id="Icons/Microsoft" transform="translate(5.125000, 37.125000)" fill="#66B2FF">
                <path
                  d="M11.28875,13.050125 L24.684,13.050125 C24.690875,16.949625 24.684,20.84775 24.684,24.75 C20.23175,24.08175 15.769875,23.463 11.309375,22.859375 C11.3025,19.589625 11.29425,16.32125 11.28875,13.050125 L11.28875,13.050125 Z M0,12.9195 C3.361875,12.9085 6.722375,12.9635 10.08425,12.958 C10.08425,16.2085 10.0925,19.460375 10.087,22.710875 C6.72925,22.213125 3.364625,21.778625 0,21.3235 L0,12.9195 Z M0,3.518625 C3.353625,3.001625 6.721,2.55475 10.087,2.135375 C10.08975,5.377625 10.08975,8.617125 10.0925,11.86075 C6.72925,11.858 3.364625,11.908875 0,11.89925 L0,3.518625 Z M11.309375,1.942875 C15.761625,1.260875 20.2235,0.61875 24.684,0 C24.688125,3.9105 24.684,7.816875 24.688125,11.727375 C20.229,11.743875 15.769875,11.812625 11.309375,11.826375 C11.306625,8.529125 11.306625,5.234625 11.309375,1.942875 L11.309375,1.942875 Z"
                  id="🎨-Icon-Colour"/>
              </g>
              <polygon id="Path-2" stroke="#6F7786" stroke-width="2" opacity="0.300000012"
                stroke-linecap="square" stroke-linejoin="round"
                points="182.257012 128.210503 190.572486 128.210503 190.572486 119.5 195.353977 119.5 186.5 110.811503 177.762302 119.511003 182.257012 119.511003"/>
              <polygon id="Path-2" stroke="#6F7786" stroke-width="2" opacity="0.300000012"
                stroke-linecap="square" stroke-linejoin="round"
                points="182.257012 37.2105035 190.572486 37.2105035 190.572486 28.5 195.353977 28.5 186.5 19.8115031 177.762302 28.5110033 182.257012 28.5110033"/>
            </g>
          </g>
        </g>
      </svg>
    </div>

    <h3 class="text-center m-b-16">
      {{ ('Ticket_Template.Image_Cannot_Load_Title' | trans) | async }}
    </h3>
    <div class="text-center">
      {{ ('Ticket_Template.Image_Cannot_Load_Body' | trans) | async }}
    </div>
  </div>
  <div slot="footer" class="col-12">
    <div class="row">
      <div class="col-12 text-center">
        <cm-button
          (click)="returnToOverview()"
          data-label="{{('Ticket_Template.Return_Overview_Button' | trans) | async}}"
          data-button-type="icon-text"
          data-icon="left"
          data-custom-class="m-l-16"
          data-button-style="cta">
        </cm-button>
      </div>
    </div>
  </div>
</cm-dialog>
